// External Imports
import { useState, useEffect } from "react";
import { MdOutlinePhotoSizeSelectActual } from "react-icons/md";
import { AiOutlineEdit, AiOutlineDelete, AiOutlineEye, AiOutlineSave } from "react-icons/ai";

// Internal Imports
import UploadButtonWrapper from "components/UploadButtonWrapper";
import KeywordSelect from "components/forms/KeywordSelect";
import ProductSelect from "components/forms/ProductSelect";
import TagSelect from "components/forms/TagSelect";

const BlogPreview = ({ blog, isEditing, setIsEditing, onSave, onDelete }) => {
  const [title, setTitle] = useState("");
  const [author, setAuthor] = useState("");
  const [keywords, setKeywords] = useState([]);
  const [products, setProducts] = useState([]);
  const [tags, setTags] = useState([]);
  const [photo, setPhoto] = useState(null);
  const [content, setContent] = useState([]);

  useEffect(() => {
    if (blog) {
      setTitle(blog.title || "");
      setAuthor(blog.author || "");
      setKeywords(blog.keywords || []);
      setProducts(blog.products || []);
      setTags(blog.tags || []);
      setPhoto(blog.photo || null);
      setContent(blog.content || []);
    } else {
      reset();
    }
  }, [blog]);

  const reset = () => {
    setTitle("");
    setAuthor("");
    setKeywords([]);
    setProducts([]);
    setTags([]);
    setPhoto(null);
    setContent([]);
  };

  const handleSave = () => {
    onSave({
      id: blog.id || null,
      title,
      author,
      keywords,
      products,
      tags,
      photo,
      content,
    });
  };

  return (
    <div
      style={{
        boxSizing: "border-box",
        padding: "30px 50px",
        background: "white",
        height: "100%",
        width: "100%",
        borderRadius: 20,
      }}
    >
      {blog || isEditing ? (
        <div style={{ display: "flex", flexFlow: "column", height: "100%" }}>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <AiOutlineDelete style={{ fontSize: 24, color: "#8B0000", marginRight: 5 }} onClick={onDelete} />
            <AiOutlineSave style={{ fontSize: 24, marginRight: 5 }} onClick={handleSave} />
            {isEditing ? (
              <AiOutlineEye style={{ fontSize: 24 }} onClick={() => setIsEditing(false)} />
            ) : (
              <AiOutlineEdit style={{ fontSize: 24 }} onClick={() => setIsEditing(true)} />
            )}
          </div>

          <div
            style={{
              flexDirection: "column",
              alignItems: "center",
              padding: "0px 5px",
              overflowY: "auto",
              display: "flex",
              flexGrow: 1,
            }}
          >
            {isEditing ? (
              <input
                style={{ fontSize: 40 }}
                placeholder="Title"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            ) : (
              <div style={{ fontSize: 40 }}>{title}</div>
            )}

            {isEditing ? (
              <input
                style={{ fontSize: 18, marginTop: 5 }}
                placeholder="Author"
                value={author}
                onChange={(e) => setAuthor(e.target.value)}
              />
            ) : (
              <div style={{ fontSize: 18 }}>By: {author}</div>
            )}

            <UploadButtonWrapper
              disabled={!isEditing}
              onChange={(files) => files.length > 0 && setPhoto(files[0])}
              style={{
                justifyContent: "center",
                alignItems: "center",
                margin: "30px 0px",
                display: "flex",
                height: 250,
              }}
            >
              {photo && photo.downloadURL ? (
                <img
                  src={photo.downloadURL}
                  alt="blog"
                  style={{ height: "100%", objectFit: "cover", borderRadius: 14 }}
                />
              ) : (
                <MdOutlinePhotoSizeSelectActual style={{ fontSize: 200 }} />
              )}
            </UploadButtonWrapper>

            {isEditing ? (
              <input
                style={{ fontSize: 16, width: "100%", marginBottom: 30 }}
                placeholder="Content"
                value={content}
                onChange={(e) => setContent(e.target.value)}
              />
            ) : (
              <div style={{ fontSize: 16, width: "100%", marginBottom: 30 }}>
                {content ? content : "No blog conent"}
              </div>
            )}

            {isEditing ? (
              <KeywordSelect
                style={{ fontSize: 16, width: "100%", marginBottom: 30 }}
                value={keywords}
                onChange={(kws) => setKeywords(kws)}
              />
            ) : (
              <div style={{ fontSize: 16, width: "100%", marginBottom: 30 }}>
                {Array.isArray(keywords) && keywords.length > 0 ? keywords : "No blog keywords"}
              </div>
            )}

            {isEditing ? (
              <ProductSelect
                style={{ fontSize: 16, width: "100%", marginBottom: 30 }}
                value={products}
                onChange={(ps) => setProducts(ps)}
              />
            ) : (
              <div style={{ fontSize: 16, width: "100%", marginBottom: 30 }}>
                {Array.isArray(products) && products.length > 0 ? keywords : "No blog products"}
              </div>
            )}

            {isEditing ? (
              <TagSelect
                style={{ fontSize: 16, width: "100%", marginBottom: 30 }}
                value={tags}
                onChange={(ts) => setTags(ts)}
              />
            ) : (
              <div style={{ fontSize: 16, width: "100%", marginBottom: 30 }}>
                {Array.isArray(tags) && tags.length > 0 ? keywords : "No blog tags"}
              </div>
            )}
          </div>
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            fontSize: 30,
          }}
        >
          Select a blog to preview
        </div>
      )}
    </div>
  );
};

export default BlogPreview;
